module.exports = __webpack_public_path__ + "media/svg-new/boss1-6d0e5b83.svg";